import { render, staticRenderFns } from "./TGIF.vue?vue&type=template&id=58aab852&scoped=true"
import script from "./TGIF.vue?vue&type=script&lang=js"
export * from "./TGIF.vue?vue&type=script&lang=js"
import style0 from "./TGIF.vue?vue&type=style&index=0&id=58aab852&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58aab852",
  null
  
)

export default component.exports